// Scroll to the active item in the main menu using the classname set in the Wagtail hooks.
(($) => {
  $(document).ready(() => {
    let explorer_menu_item = $("li.menu-item.menu-active");
    if (explorer_menu_item) {
      explorer_menu_item.removeClass("menu-active");
      let content_type_menu_item = $("a.menu-active");
      if(content_type_menu_item.length > 0){
        content_type_menu_item[0].scrollIntoView();
      }
    }
  });
})(jQuery);
